import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import P from '@deliveroo/consumer-component-library/components/P';

import styles from './styles.scss';

/**
 * A generic dynamic actions template to render a red-coloured button that cancels an order.
 */
function OrderStatusCancelOrderButton({
  orderId,
  statusButtonText,
  actionId,
  actionTemplate,
  selectedActionId,
  selectedActionTemplate,
  openOrderHelpModal,
}) {
  return (
    <Fragment>
      <button
        type="button"
        className={styles['cancel-order-button']}
        onClick={() => {
          openOrderHelpModal({
            actionId,
            actionTemplate,
            selectedActionId,
            selectedActionTemplate,
          });
        }}
      >
        {statusButtonText}
      </button>

      <div className={styles['cancel-order-link']}>
        <P size="small">
          <a
            href={`/orders/${orderId}/help?redirectTo=/orders/${orderId}/status&daai=${actionId}&daat=${actionTemplate}&dasai=${selectedActionId}&dasat=${selectedActionTemplate}`}
            aria-label={statusButtonText}
            title={statusButtonText}
          >
            {statusButtonText}
          </a>
        </P>
      </div>
    </Fragment>
  );
}

OrderStatusCancelOrderButton.defaultProps = {
  openOrderHelpModal: () => {},
};

OrderStatusCancelOrderButton.propTypes = {
  /** Id of the order */
  orderId: PropTypes.string.isRequired,
  /** The text of the button */
  statusButtonText: PropTypes.string.isRequired,
  actionId: PropTypes.string.isRequired,
  actionTemplate: PropTypes.string.isRequired,
  selectedActionId: PropTypes.string.isRequired,
  selectedActionTemplate: PropTypes.string.isRequired,
  /**
   * Action to open the OrderHelpModal to a specific page for OrderHelpModal
   */
  openOrderHelpModal: PropTypes.func,
};

export default OrderStatusCancelOrderButton;
